module["exports"] = [
  "#{prefix} #{Name.first_name}",
  "#{Name.first_name} #{suffix}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ko/company/name.js
// module id = 1487
// module chunks = 1